import React from 'react';
import { groupsFor, mapShort } from './mapdefs';

interface Props {
  scope: 'person' | 'co';
  maps: string[];
  onChange: (next: string[]) => void;
}

/** 항목 → 뒷단계 연동(여러 건). 칩 클릭 시 해제, 셀렉트로 추가 */
export default function MapPicker({ scope, maps, onChange }: Props) {
  const groups = groupsFor(scope);
  return (
    <div className="maprow" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 6 }}>
      <span style={{ fontWeight: 700 }}>단계 연동</span>
      {maps.length === 0 ? <span style={{ color: 'var(--muted)' }}>없음 · 제출값이 뒷단계에 자동으로 흐르게 하려면 추가하세요</span> : null}
      {maps.map((k) => (
        <span
          key={k}
          className="pill p-blue"
          style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
          title="클릭하면 연동 해제"
          onClick={() => onChange(maps.filter((x) => x !== k))}
        >
          → {mapShort(k)} ×
        </span>
      ))}
      <select
        className="itype"
        value=""
        onChange={(e) => { const v = e.target.value; if (v && !maps.includes(v)) onChange([...maps, v]); }}
      >
        <option value="">＋ 연동 추가</option>
        {groups.map((g) => (
          <optgroup label={g.label} key={g.label}>
            {g.defs.filter((d) => !maps.includes(d.key)).map((d) => (
              <option value={d.key} key={d.key}>{d.label}</option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
}
